import { PropsWithChildren } from "react"

interface Props {
  title: string
  number: number
  description: string
}
export const WhyUsCard = ({ title, number, description, children }: PropsWithChildren<Props>) => {
  return (
    <div className="why-us__card">
      <div className="why-us__card__img">{children}</div>
      <div className="why-us__card--content">
        <div className="why-us__card--content-number">{number}</div>
        <div className="why-us__card--content-description">
          <h3 className="why-us__card--content-title">{title}</h3>
          <p className="why-us__card--content-text">{description}</p>
        </div>
      </div>
    </div>
  )
}
